import { render, staticRenderFns } from "./Student_Class.vue?vue&type=template&id=49f6feea&scoped=true&"
import script from "./Student_Class.vue?vue&type=script&lang=js&"
export * from "./Student_Class.vue?vue&type=script&lang=js&"
import style0 from "./Student_Class.vue?vue&type=style&index=0&id=49f6feea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f6feea",
  null
  
)

export default component.exports